import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { LocalNotification } from '@amzn/aac-chrome-internal-api';
import { bannerMetricsPublisher } from 'src/features/header/components/Banners/types';
import { logWithTakt } from '../../utils/logWithTakt';
import { updateShouldOpenCarouselModal } from 'src/features/header/store/slice';
import { BANNER_LEVEL } from 'src/app/slice';
import { ConnectedBannerTriggeredCarouselModal } from 'src/features/header/components/Banners/Common/BannerTriggeredCarouselModal';
import { AcesBannerContent } from './AcesBannerContent';
import { clickLinkHandler } from './utils';
import { BannerContentWrapper, BannerLink } from './styles';
import { BannerText } from 'src/features/header/components/Banners/styles';

interface BannerContentProps {
  banner: LocalNotification;
  setShouldAutoOpenModal: (...args: any[]) => any;
  bannerLevel: BANNER_LEVEL;
  isRenderedInModal?: boolean;
}

export const BannerContent: React.VFC<BannerContentProps> = ({
  banner,
  setShouldAutoOpenModal,
  bannerLevel,
  isRenderedInModal = true,
}) => {
  const modalTrigger = useRef(null);
  useEffect(() => {
    bannerMetricsPublisher[bannerLevel].publishCounterMonitor(
      `${bannerLevel}BannerRendered:${banner.id}`,
      1,
    );
    logWithTakt(`${bannerLevel}BannerRendered`, { bannerId: banner.id });
  }, []);

  const acesBannerContent = banner.acesBannerContent;
  return acesBannerContent ? (
    <AcesBannerContent
      acesBannerContent={acesBannerContent}
      bannerLevel={bannerLevel}
      bannerId={banner.id}
      bannerType={banner.type}
    />
  ) : (
    <BannerContentWrapper isRenderedInModal={isRenderedInModal}>
      {banner.title && (
        <BannerText>
          <strong>{banner.title}</strong>
        </BannerText>
      )}
      {(isRenderedInModal || (!isRenderedInModal && !banner.title)) && (
        <BannerText>{banner.message}</BannerText>
      )}
      {banner.link && (
        <BannerLink
          size="small"
          href={banner.link.url}
          aria-label={banner.message + banner.link.label}
          onClick={() => clickLinkHandler(bannerLevel, banner.id)}
          isRenderedInModal={isRenderedInModal}
        >
          {banner.link.label}
        </BannerLink>
      )}
      {banner.modal && (
        <>
          <BannerLink
            href="#"
            aria-label={banner.message + banner.modal.label}
            onClick={(e) => {
              e.preventDefault();
              setShouldAutoOpenModal(true);
            }}
            isRenderedInModal={isRenderedInModal}
          >
            {banner.modal.label}
          </BannerLink>
          <ConnectedBannerTriggeredCarouselModal
            banner={banner}
            modalTrigger={modalTrigger}
          />
        </>
      )}
    </BannerContentWrapper>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setShouldAutoOpenModal: (shouldOpen) =>
      dispatch(updateShouldOpenCarouselModal(shouldOpen)),
  };
};

export const ConnectedBannerContent = connect(
  null,
  mapDispatchToProps,
)(BannerContent);
